import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { OnSubmitValidationError, FormikForm, ButtonOBSOLETED, Loader } from '../../web.common';
import { cloneObject } from '../../common/utils';

class CreatableArea extends React.Component {
  constructor(props) {
    super(props);
    const { isEditMode = false } = props;

    this.state = {
      isEditMode,
      isToggling: false
    };

    this.receivedFormikProps = null;
    this.onValidationError = this.onValidationError.bind(this);
  }

  onValidationError() {
    const { onValidationError: passedValidationErrorHandler } = this.props;
    const { receivedFormikProps } = this;

    if (!passedValidationErrorHandler) {
      return;
    }

    passedValidationErrorHandler(receivedFormikProps);
  }

  render() {
    const {
      props,
      state: {
        isEditMode,
        isToggling
      }
    } = this;

    const {
      isLoading,
      loadingText,
      savingText,
      onSubmit: passedSubmitHandler,
      buttonStyleType,
      children
    } = props;

    const isEditorProcessing = isLoading || isToggling;
    const sharedIconAttributes = { style: { color: 'inherit' } };

    const addedFormProps = {
      formClassNames: [
        'creatable-area',
        'editable-area',
        `mode-${isEditMode ? 'edit' : 'print'}`
      ],
      getFormikProps: receivedFormikProps => {
        this.receivedFormikProps = receivedFormikProps;
      },
      ignoreAbandoningDirtyForm: true
    };

    const excludedFormProps = [
      'children',
      'isEditMode',
      'ariaEditorName'
    ];

    const passedFormikProps = cloneObject(props, addedFormProps, excludedFormProps);
    passedFormikProps.onSubmit = values => passedSubmitHandler({ values });

    return (
      <Loader hasLoaded={!isLoading} loadingText={isEditMode ? savingText : loadingText}>
        <FormikForm {...passedFormikProps}>
          <OnSubmitValidationError callback={this.onValidationError} />
          { children }
          <ButtonOBSOLETED
            className={buttonStyleType !== 'wrap' ? 'itemgap-right' : null}
            type='submit'
            appearance={buttonStyleType}
            ariaLabel='Save'
            disabled={isEditorProcessing}
            buttonContent='Save'
            iconName='check'
            iconAttributes={sharedIconAttributes}
          />
        </FormikForm>
      </Loader>
    );
  }
}

CreatableArea.propTypes = {
  initialValues: PropTypes.object.isRequired,
  handleDirtyForm: PropTypes.func,
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  validationSchema: PropTypes.object,
  formClassNames: PropTypes.arrayOf(PropTypes.string),
  savingText: PropTypes.string,
  loadingText: PropTypes.string,
  ariaEditorName: PropTypes.string.isRequired,
  buttonStyleType: PropTypes.oneOf(['wrap', 'outline']),
  isEditMode: PropTypes.bool,
  isLoading: PropTypes.bool,
  onValidationError: PropTypes.func
};

export default connect(({ user }) => ({ user }))(CreatableArea);